import { render, staticRenderFns } from "./quarterlycorrection.html?vue&type=template&id=72ed162f&"
import script from "./QuarterlyCorrection.vue?vue&type=script&lang=js&"
export * from "./QuarterlyCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports